var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUrl = function SvgUrl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.002,
    height: 13,
    viewBox: "0 0 13.002 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a8b1bf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M664.956,388.385l-.658.654a1.472,1.472,0,0,1-2.067,0,1.431,1.431,0,0,1-.012-2.022l.012-.012,2.422-2.4c.5-.5,1.445-1.23,2.134-.548a.806.806,0,1,0,1.187-1.092c-.017-.018-.034-.034-.052-.051-1.17-1.161-2.9-.946-4.4.547l-2.422,2.4a3.039,3.039,0,0,0-.02,4.3l.02.021a3.09,3.09,0,0,0,4.338,0l.658-.654a.806.806,0,1,0-1.1-1.18C664.98,388.36,664.968,388.372,664.956,388.385Zm7.338-9.337a2.877,2.877,0,0,0-4.061-.261c-.042.037-.08.073-.119.111l-.82.814a.806.806,0,0,0,1.1,1.178c.013-.011.025-.024.037-.035l.82-.813a1.3,1.3,0,0,1,1.838.07c.025.028.05.057.072.086a1.43,1.43,0,0,1,.012,2.022l-.012.012-2.582,2.561c-1.182,1.172-1.735.622-1.971.388a.806.806,0,0,0-1.135,1.143,2.544,2.544,0,0,0,1.811.8,3.544,3.544,0,0,0,2.43-1.193l2.583-2.562a3.041,3.041,0,0,0,.022-4.3l-.022-.021Z",
    transform: "translate(-660.196 -378.071)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUrl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/url.a57f4399.svg";
export { ForwardRef as ReactComponent };